"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserVersion = void 0;
const airbridge_web_sdk_loader_1 = __importDefault(require("airbridge-web-sdk-loader"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const BrowserVersion = ({ user, saveAirbridgeWebInfo }) => {
    const [airbridgeClientUuid, setAirbridgeClientUuid] = (0, react_1.useState)('');
    const [browserName, setBrowserName] = (0, react_1.useState)('');
    const [userAgent, setUserAgent] = (0, react_1.useState)('');
    const [browserVersion, setBrowserVersion] = (0, react_1.useState)('');
    const getBrowserName = (_userAgent) => {
        // Check for specific browser keywords in the user agent string
        if (_userAgent.includes('Firefox')) {
            return 'Firefox';
        }
        if (_userAgent.includes('Chrome')) {
            return 'Chrome';
        }
        if (_userAgent.includes('Safari')) {
            return 'Safari';
        }
        if (_userAgent.includes('MSIE') || _userAgent.includes('Trident/')) {
            return 'MSIE';
        }
        if (_userAgent.includes('Edge')) {
            return 'Edge';
        }
        if (_userAgent.includes('Opera') || _userAgent.includes('OPR/')) {
            return 'Opera';
        }
        return 'Unknown';
    };
    const getBrowserVersion = (_userAgent) => {
        let version = '';
        const regexPatterns = {
            'Firefox': /Firefox\/([\d.]+)/,
            'Chrome': /Chrome\/([\d.]+)/,
            'Safari': /Version\/([\d.]+).*Safari/,
            'Edge': /Edge\/([\d.]+)/,
            'Opera': /(Opera|OPR)\/([\d.]+)/,
            'MSIE': /(MSIE|rv:)\s?([\d.]+)/
        };
        Object.keys(regexPatterns).forEach((_browserName) => {
            const regex = regexPatterns[_browserName];
            const matches = _userAgent.match(regex);
            if (matches) {
                [, version] = matches;
            }
        });
        return version || 'Unknown';
    };
    (0, react_1.useEffect)(() => {
        if (user === null || user === void 0 ? void 0 : user.id) {
            const _userAgent = navigator.userAgent;
            const _browserName = getBrowserName(_userAgent);
            const _browserVersion = getBrowserVersion(_userAgent);
            setBrowserName(_browserName);
            setUserAgent(_userAgent);
            setBrowserVersion(_browserVersion);
            airbridge_web_sdk_loader_1.default.fetchResource((res) => {
                setAirbridgeClientUuid(res.browser.clientID);
            });
        }
        else {
            setBrowserName("");
            setUserAgent("");
            setBrowserVersion("");
            setAirbridgeClientUuid("");
        }
    }, [user]);
    (0, react_1.useEffect)(() => {
        if ((browserName || browserVersion || userAgent) && airbridgeClientUuid) {
            saveAirbridgeWebInfo({
                airbridge_client_id: airbridgeClientUuid,
                airbridge_client_name: browserName,
                airbridge_client_useragent: userAgent,
                airbridge_client_version: browserVersion
            });
        }
    }, [browserName, browserVersion, userAgent, airbridgeClientUuid]);
    return (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.BrowserVersion = BrowserVersion;
const mapStateToProps = (state) => ({ user: selectors_1.default.user.getUser(state), });
const mapDispatchToProps = {
    saveAirbridgeWebInfo: (data) => redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.saveAirbridgeWebInfoPayload)(data)),
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(exports.BrowserVersion);
